/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Terms_Import_Terms_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to import terms: {error}" |
*
* @param {Knp_Terms_Import_Terms_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_import_terms_failed = /** @type {((inputs: Knp_Terms_Import_Terms_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Import_Terms_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l’importation des termes : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Begriffe konnten nicht importiert werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile importare i termini: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось импортировать термины: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al importar términos: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导入术语失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`用語のインポートに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`शर्तें आयात करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao importar os termos: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to import terms: ${i?.error}`)
});